import React, {Component} from 'react'
import Hammer from 'react-hammerjs'
import ReactHowler from 'react-howler'
import raf from 'raf'

import Icon from '../../Global/Icon'

class BlockAudio extends Component {
  constructor (props) {
    super(props)

    this.isDragging = false
    this.state = {
      playing: false,
      loaded: false,
      loop: false,
      mute: false,
      volume: 1.0,
      deltaX: 0,
    }

    this.handlePan = this.handlePan.bind(this)
    this.handlePanEnd = this.handlePanEnd.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
    this.handleOnLoad = this.handleOnLoad.bind(this)
    this.handleOnEnd = this.handleOnEnd.bind(this)
    this.handleOnPlay = this.handleOnPlay.bind(this)
    this.handleStop = this.handleStop.bind(this)
    this.renderSeekPos = this.renderSeekPos.bind(this)
    this.handleLoopToggle = this.handleLoopToggle.bind(this)
    this.handleMuteToggle = this.handleMuteToggle.bind(this)
  }
  convertStringValueToNumber = (styleTarget, property, unity) => parseFloat(styleTarget.getPropertyValue(property).replace(unity, ''))
  componentWillMount() {
    this.setState({ playing: false })
  }
  componentWillUnmount () {
    this.clearRAF()
  }
  handleToggle () {
    this.setState({
      playing: !this.state.playing
    })
  }
  handlePan(e) {
    const target = e.target
    const {deltaX} = this.state
    const parentTarget = e.target.parentElement
    const parentStyleTarget = window.getComputedStyle(parentTarget)
    const currentParentTargetWidthPosition = this.convertStringValueToNumber(parentStyleTarget, 'width', 'px')

    let newTargetLeftPosition = e.deltaX + deltaX

    if (newTargetLeftPosition < 0) {
      newTargetLeftPosition = 0
    } else if (newTargetLeftPosition > currentParentTargetWidthPosition) {
      newTargetLeftPosition = currentParentTargetWidthPosition
    }

    target.style.left = newTargetLeftPosition + 'px'
  }
  handlePanEnd(e) {
    const target = e.target
    const styleTarget = window.getComputedStyle(target)
    const currentTargetWidthPosition = this.convertStringValueToNumber(styleTarget, 'left', 'px')
    const parentTarget = e.target.parentElement
    const parentStyleTarget = window.getComputedStyle(parentTarget)
    const currentParentTargetWidthPosition = this.convertStringValueToNumber(parentStyleTarget, 'width', 'px')
    const percentageBetweenTargetAndParent = currentTargetWidthPosition / currentParentTargetWidthPosition
    const { duration } = this.state

    this.setState({
      deltaX: currentTargetWidthPosition
    })

    this.setSeek(duration * percentageBetweenTargetAndParent)
  }
  handleOnLoad () {
    this.setState({
      loaded: true,
      duration: this.player.duration()
    })
  }

  handleOnPlay () {
    this.setState({
      playing: true
    })
    this.renderSeekPos()
  }

  handleOnEnd () {
    this.setState({
      playing: false
    })
    this.clearRAF()
  }

  handleStop () {
    this.player.stop()
    this.setState({
      playing: false // Need to update our local state so we don't immediately invoke autoplay
    })
    this.renderSeekPos()
  }

  handleLoopToggle () {
    this.setState({
      loop: !this.state.loop
    })
  }

  handleMuteToggle () {
    this.setState({
      mute: !this.state.mute
    })
  }

  renderSeekPos () {
    this.setState({
      seek: this.player.seek()
    })
    if (this.state.playing) {
      this._raf = raf(this.renderSeekPos)
    }
  }
  getSeek() {
    return this.player.seek()
  }
  setSeek(seek) {
    this.player.seek(seek)
  }
  clearRAF () {
    raf.cancel(this._raf)
  }
  /**
   * Convert Seconds to the following format: mm:ss
   * @param {Number} time Time to convert
   */
  secondsToMin(time, separator = ':') {
    const min = (Math.floor(time / 60).toString().length === 1 ? '0' : '') + Math.floor(time / 60).toString()
    const sec = (Math.floor(time % 60).toString().length === 1 ? '0' : '') + Math.floor(time % 60).toString()

    return min + separator + sec
  }
  render() {
    const { bloc: { sound_file: { url }, indication, title } } = this.props
    const { seek, loop, mute, volume, duration, playing } = this.state

    return (
      <div className="block block--audio">
        <div className="player">
          <h3 className="block__title">{title}</h3>
          <p className="block__text">{indication}</p>
          <div className="player__holder">
            <button type="button" className={`player__button ${playing ? 'player__button--pause' : ''} button button--text play`} onClick={this.handleToggle}>
              <div className="player__button-icon" />
            </button>
            <div className="player__timeline">
              <Hammer onPan={this.handlePan} onPanEnd={this.handlePanEnd} direction="DIRECTION_HORIZONTAL">
                <div className="player__cursor" style={{left: `${Math.floor((seek / duration) * 100)}%`}} />
              </Hammer>
              <div className="player__currenttime" style={{width: `${Math.floor((seek / duration) * 100)}%`}} />
            </div>
            <div className="player__timecode">
              {(seek !== undefined) ? this.secondsToMin(seek.toFixed(2)) : '00:00'}
            </div>
            <div className="player__sound">
              <button type="button" className="player__mute button button--icon button--text" onClick={this.handleMuteToggle}>
                {!mute && <Icon className="icon icon-sound" icon="sound" />}
                {mute && <Icon className="icon icon-sound" icon="sound-mute" />}
              </button>
              <input
                className="player__volume"
                type="range"
                min="0"
                max="1"
                step=".05"
                value={volume}
                onChange={e => this.setState({volume: parseFloat(e.target.value)})}
              />
            </div>
            <ReactHowler
              src={url}
              playing={playing}
              html5={true}
              onLoad={this.handleOnLoad}
              onPlay={this.handleOnPlay}
              onEnd={this.handleOnEnd}
              loop={loop}
              mute={mute}
              volume={volume}
              ref={(ref) => (this.player = ref)}
            />
          </div>
        </div>
      </div>
    )
  }
}
export default BlockAudio



// WEBPACK FOOTER //
// ./src/components/Block/BlockAudio/BlockAudio.js